// Import from NPM
// -------------------------------------
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@components/Generics.react";
import { Input } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

// Import from Config
// -------------------------------------
import { baseUrl } from "@api/apiV6";
import AuthLayout from "@layouts/AuthLayout.react";
import { Div } from "@components/Generics.react";

// Import Components
// -------------------------------------

export default function ChangePassword(props) {
    const auth = useSelector((state) => state.auth);
    const [currentPassword, setCurrentPassword] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPass, setConfirmPass] = useState("");
    const [error, setError] = useState(null);
    const [validPassword, setValidPassword] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation("common");
    const { state } = useLocation();

    useEffect(() => {
        if (password.length > 0 && confirmPass.length > 0) {
            if (password !== confirmPass) setError("Passwords do not match...");
            else setError(null);
        }
    }, [password, confirmPass]);

    useEffect(() => {
        const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        setValidPassword(passwordPattern.test(password));
    }, [password]);

    const tryReset = async () => {
        if (!validPassword) {
            setError("Password does not meet the requirements...");
            return;
        }

        try {
            let formData = new FormData();
            formData.append("current_password", currentPassword);
            formData.append("password", password);
            formData.append("password_confirmation", confirmPass);
            await axios({
                method: "post",
                url: `${baseUrl}api/v3/auth/change_password`,
                data: formData,
                headers: { "access-token": auth.token },
            });
            navigate(state?.from?.pathname || "/");
        } catch (error) {
            setError(error.response.data.message);
        }
    };
    // ========================= Render Function =================================
    return (
        <AuthLayout title={`Login to ${t("appName")}`}>
            <Div fluid white fullHt>
                <Div massive altText fluid center-align gutter>
                    CHANGE PASSWORD
                </Div>
                {error && (
                    <Div padded fluid danger gutter>
                        {error}
                    </Div>
                )}
                <Div fluid gutter>
                    <Input
                        fluid
                        label="Current Password"
                        type="password"
                        placeholder="Input Current Password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                    />
                    <br />
                    <Input
                        fluid
                        label="New Password"
                        type="password"
                        placeholder="Input New Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    {password && !validPassword && (
                        <Div charcoal padded small italics>
                            {t("auth.registration.passwordHelp")}
                        </Div>
                    )}
                    <br />
                    <Input
                        fluid
                        label="Confirm New Password"
                        placeholder="Re-enter New Password"
                        value={confirmPass}
                        onChange={(e) => setConfirmPass(e.target.value)}
                    />
                    <br />
                    <Button
                        content="Cancel"
                        onClick={() => navigate(-1)}
                    />
                    <Button primary content="Submit" onClick={tryReset} />
                </Div>
            </Div>
        </AuthLayout>
    );
}
